<section class="content" data-tour="dash-my-prescriptions">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[
          { label: 'MIS RECETAS' }]">
      </app-breadcrumb>
    </div>
    <app-top-widgets/>
    <app-prescription-by-id-patient [control]="1"/>
  </div>
</section>
